// @ts-nocheck
import React, { useEffect, useState } from "react";
import SoftBox from "../../components/common/softBox";
import SoftTypography from "../../components/common/softTypography";
import SoftButton from "../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { createCms, getCmsByType } from "../../features/cms";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ManageCms: React.FC<{
  type: "privacy_policy" | "terms_and_conditions";
}> = ({ type }) => {
  const { cms, status } = useSelector((state) => state.cms);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");

  const [formData, setFormData] = useState({
    content: "",
  });

  useEffect(() => {
    setFormData({
      content: "",
    });
    dispatch(getCmsByType({ type, lan: language }));
  }, [dispatch, type, language]);

  useEffect(() => {
    // // console.log("cms", cms);

    if (cms && cms.data && cms.data.content) {
      setFormData({ content: cms.data.content });
    } else {
      setFormData({ content: "" });
    }
  }, [cms, status]);

  const handleChange = (event: any, editor: any) => {
    const data = editor.getData();
    setFormData((prev) => ({
      ...prev,
      content: data,
    }));
  };

  const handleSubmit = (isUpdate = false) => {
    // const action = isUpdate ? updateCmsEntry : createCms;

    dispatch(createCms({ type, content: formData.content, lan: language }))
      .then((res) => {
        toast.success(res.payload.message);
        navigate("/cms");
      })
      .catch((err) => {
        toast.error("Error: " + err.message);
      });
  };

  // // // console.log(language, 'language');

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold">
            Manage{" "}
            {type === "privacy_policy"
              ? "Privacy Policy"
              : "Terms And Conditions"}
          </SoftTypography>
        </SoftBox>

        <SoftBox mb={2}>
          <SoftBox>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Language
            </SoftTypography>
          </SoftBox>

          <FormControl fullWidth size="small">
            <Select
              name="language"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              IconComponent={KeyboardArrowDownIcon}
              fullWidth
              size="small"
              sx={{
                padding: "0px 8px !important",
                height: "40px !important",
                display: "block !important",
                ".MuiSelect-select": {
                  padding: "0px 8px !important",
                  height: "40px !important",
                },
                ".MuiSelect-nativeInput": {
                  height: "40px !important",
                },
                ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
                ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
              }}
            >
              <MenuItem value={"en"}>English</MenuItem>
              <MenuItem value={"ar"}>Arabic</MenuItem>
            </Select>
          </FormControl>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* CKEditor for Content */}
          <SoftBox mb={2}>
            <SoftBox>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Content
              </SoftTypography>
            </SoftBox>
            <CKEditor
              editor={ClassicEditor}
              data={formData.content}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={() => handleSubmit()}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default ManageCms;
